// extracted by mini-css-extract-plugin
export var card = "_s2-0";
export var details = "_s2-1";